<template>
  <div class="room-attendance-table-component">
    <div class="room-attendance-table-wrapper">
      <table class="room-attendance-table">
        <colgroup>
          <col width="4%">
          <col width="4%">
          <col width="6%">
          <col width="6%">
          <col width="4%">
          <col width="4%">
          <col width="7%">
        </colgroup>
        <thead>
          <tr>
            <th>{{ $t("common.name") }}</th>
            <th>{{ $t("attendance.modal.nowEntered") }}</th>
            <th>{{ $t("attendance.list.init") }}</th>
            <th>{{ $t("attendance.list.last") }}</th>
            <th>{{ $t("attendance.list.total") }}</th>
            <th>{{ $t("attendance.list.kickCount") }}</th>
            <th>Email</th>
          </tr>
        </thead>
      </table>
    </div>
    <perfect-scrollbar>
      <div class="room-attendance-table-wrapper body">
        <table class="room-attendance-table">
          <colgroup>
            <col width="4%">
            <col width="4%">
            <col width="6%">
            <col width="6%">
            <col width="4%">
            <col width="4%">
            <col width="7%">
          </colgroup>
          <tbody>
            <tr v-for="(attendance, i) in attendanceList" :key="i">
              <td class="bold" :class="{ me: attendance.userId === me.userId }">{{ attendance.nickname || attendance.username }}</td>
              <td>{{ attendance.present ? 'O':'X' }}</td>
              <td>{{ getFormedDate(attendance.firstEnter) }}</td>
              <td>{{ !attendance.lastLeave ? '-' : getFormedDate(attendance.lastLeave) }}</td>
              <td>{{ getDurationDate(attendance.totalAttendingSeconds) }}</td>
              <td>{{ attendance.kickCount }}</td>
              <td>{{ attendance.email || $t('attendance.modal.nonMember')}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </perfect-scrollbar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment/moment";

export default {
  name: 'RoomAttendanceTable',
  props:{
    attendanceList: { type: Array,  required: true },
  },
  computed:{
    ...mapGetters('user', [
      'me',
    ]),
    getFormedDate() {
      return date => {
        return date && moment(date).format('YY-MM-DD HH:mm:ss');
      }
    },
    getDurationDate() {
      return sec => {        
        let min = 0;
        let hours = 0;

        if(sec) {
          min = parseInt(sec/60);
          hours = parseInt(min/60);
          min %= 60;
          sec %= 60;
        }
        
        return `${hours}:${(0 <= min && min<10 ? '0':'').concat(min)}:${(0 <= sec && sec < 10 ? '0':'').concat(sec)}`;
      }
    },
  },}
</script>

<style lang="scss" scoped>
.room-attendance-table-component {}
.room-attendance-table-wrapper {
  &.body {
    height: 360px;
    background: rgba(0, 0, 0, 0.02);
  }
}
.room-attendance-table {
  width: 100%;
  font-size: 13px;
  text-align: left;
  table-layout: fixed;
  thead {
    height: 32px;
    background-color: #f2f4f7;
  }
  tbody {
    tr {
      height: 46px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      background-color: #fff;
      transition: 0.1s ease-out;
      &:nth-of-type(2n) {
        background-color: rgba(0, 0, 0, 0.01);
      }
      &:hover {
        background-color: #f2f4f7;
      }
    }
  }
  th {
    padding: 0 10px;
    font-size: 12px;
    color: #999;
    text-align: center;
  }
  td {
    padding: 0 10px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    &.gray {
      color: #999;
    }
    &.bold {
      font-weight: 700;
    }
    &.me {
      color: $mainColor;
    }
  }
}
</style>